import { SortDirection } from '@angular/material/sort';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { PAGE_SIZE_DEFAULT } from '../../_common/constants';
import { QueueStatusListResponse, QueueStatusModel } from './queue-status.model';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})

export class QueueStatusService {
  constructor(private http: HttpClient,
    @Inject('API_URL') private apiUrl: string
  ) { }

  getQueueStatuses(pageIndex: number = 0, pageSize: number = PAGE_SIZE_DEFAULT, sortBy: string, sortDir: SortDirection, filter: any): Observable<QueueStatusListResponse> {
    return this.http
      .get<QueueStatusListResponse>(
        this.apiUrl + 'queueStatus/queue-status',
        {
          params: new HttpParams()
            .set('sortBy', sortBy)
            .set('sortDir', sortDir)
            .set('pageNumber', pageIndex.toString())
            .set('pageSize', pageSize.toString())
            .set('filter', JSON.stringify(filter))
        }
      );
  }
}
